import './relatorio.css';

export default function Relatorio({ aula }) {
  // Dados de exemplo caso não receba a prop 'aula'
  const data = aula || {
    matriculados: 0,
    presencas: 0,
    ausentes: 0,
    visitantes: 0,
    biblias: 0,
    revistas: 0,
    totalOfertas: 0.0
  };

  const total = Number(data.presencas) + Number(data.visitantes);
  const percentual = data.matriculados > 0 
    ? Number((100 * data.presencas) / data.matriculados).toFixed(2) 
    : "0.00";

  return (
    <div className="resumo-container">
      <div className="resumo-grid">
        <div className="resumo-row">
          <div className="label">Matriculados</div>
          <div className="value">{data.matriculados}</div>
        </div>
        <div className="resumo-row">
          <div className="cell">
            <span className="label">Presentes</span>
            <span className="value">{data.presencas}</span>
          </div>
          <div className="cell">
            <span className="label">Ausentes</span>
            <span className="value">{data.ausentes}</span>
          </div>
        </div>
        <div className="resumo-row">
          <div className="cell">
            <span className="label">Visitantes</span>
            <span className="value">{data.visitantes}</span>
          </div>
          <div className="cell">
            <span className="label">Total</span>
            <span className="value">{total}</span>
          </div>
        </div>
        <div className="resumo-row">
          <div className="cell">
            <span className="label">Total de Bíblias</span>
            <span className="value">{data.biblias}</span>
          </div>
          <div className="cell">
            <span className="label">Total de Revistas</span>
            <span className="value">{data.revistas}</span>
          </div>
        </div>
        <div className="resumo-row">
          <div className="label">Total de Ofertas</div>
          <div className="value">R$ {data.totalOfertas}</div>
        </div>
        <div className="resumo-row">
          <div className="label">Percentual</div>
          <div className="value">{percentual}%</div>
        </div>
      </div>
    </div>
  );
}